/* eslint react-hooks/exhaustive-deps: "warn" */

import { useState } from 'react';

import { useCreditReportUrl } from 'hooks/useCreditReportUrl';

import { Button } from 'ui/atoms/Button/Button';

import { DATA_BLOCKS } from 'features/product-pricing/organisms/PricingDataBlocks/PricingDataBlocks.data';
import { PricingDataPicker } from 'features/product-pricing/organisms/PricingDataPicker/PricingDataPicker';
import { PricingQuoteForm } from 'features/product-pricing/organisms/PricingQuoteForm/PricingQuoteForm';

import styles from './PricingQuote.module.scss';

export const PricingQuote = () => {
  const [selected, setSelected] = useState<Record<string, boolean>>({});
  const creditReportUrl = useCreditReportUrl();

  const chosenBlocks = DATA_BLOCKS.filter((block) => selected[block.key]);
  const chosen = chosenBlocks.map((block) => block.label);
  const fieldsCount = chosenBlocks.reduce((sum, block) => sum + block.count, 0);

  return (
    <div className={styles.quote}>
      <section className={styles.card}>
        <div className={styles.head}>
          <div className={styles.heading}>
            <span className={styles.step}>1</span>
            <h2 className={styles.title}>Tick the data you need</h2>
          </div>

          <span className={styles.summary}>
            {chosen.length} of {DATA_BLOCKS.length} selected &middot; {fieldsCount} fields
          </span>
        </div>

        <PricingDataPicker
          selected={selected}
          onToggle={(key) => setSelected((prev) => ({ ...prev, [key]: !prev[key] }))}
          onSelectAll={() => setSelected(Object.fromEntries(DATA_BLOCKS.map((block) => [block.key, true])))}
          onDeselectAll={() => setSelected({})}
        />
      </section>

      <PricingQuoteForm chosen={chosen} />

      <div className={styles.oneoff}>
        <div className={styles.oneoffText}>
          <span className={styles.oneoffTitle}>Only need one company?</span>
          <span className={styles.oneoffDescription}>Get a full business credit report - pay once, no contract.</span>
        </div>

        <Button type="blue" size="lg" suffixIcon="arrow-7" href={creditReportUrl}>
          Buy a single report
        </Button>
      </div>
    </div>
  );
};
